<template>
  <div>
    <button
      class="btn-sm btn btn-primary btn-tuvan mr-1 mb-1"
      title="Nhập kết quả tư vấn"
      @click="openDialog"
    >
      <i class="fa fa-edit"></i>
    </button>

    <el-dialog
      class="responsive customer-decision-dialog"
      width="920px"
      :visible.sync="dialogConsultResult"
      :close-on-click-modal="false"
      append-to-body
    >
      <template slot="title">
        <div class="decision-dialog__header">
          <div class="decision-dialog__title-wrap">
            <div class="decision-dialog__icon">
              <i class="fa fa-clipboard"></i>
            </div>
            <div>
              <div class="decision-dialog__title">Nhập kết quả tư vấn</div>
              <div class="decision-dialog__subtitle">Cập nhật trạng thái, cọc và ưu đãi của khách hàng</div>
            </div>
          </div>
        </div>
      </template>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form class="decision-form" autocomplete="off" @submit.prevent="handleSubmit(submitForm)">
          <section class="decision-section">
            <div class="field-label">Khách hàng quyết định <span class="text-danger">*</span></div>
            <ValidationProvider
              vid="customer_consult_id"
              name="Chọn quyết định"
              :rules="{ required: true }"
              v-slot="{ errors, classes }"
            >
              <el-select
                v-model="update.customer_consult_id"
                class="decision-select"
                clearable
                placeholder="Chọn quyết định"
                :class="classes"
                @change="handleConsult"
              >
                <el-option
                  v-for="item in CUSTOMER_SELECT_DECISION"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
              <div class="fv-plugins-message-container">
                <div class="fv-help-block">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
          </section>

          <section v-if="update.customer_consult_id === phan_van" >
            <div class="decision-note">
              <div class="decision-note__title">
                <i class="fa fa-lightbulb-o"></i>
                Lưu ý cho tư vấn viên
              </div>
              <ul class="decision-note__list">
                <li>Kể từ lúc khách hàng lên tư vấn, bạn có <strong>14 ngày</strong> để chăm sóc khách hàng.</li>
                <li>
                  Trong khoảng thời gian này, nếu khách hàng quyết định đăng ký, hãy cập nhật kết quả tư vấn tại
                  <strong>Danh sách khách hàng tư vấn</strong>.
                </li>
                <li>Nếu khách hàng chưa sẵn sàng đăng ký, hãy tư vấn đặt cọc để giữ quyền lợi ưu đãi.</li>
              </ul>
              <div class="decision-note__grid">
                <div class="decision-pill">
                  <div class="decision-pill__icon decision-pill__icon--purple">
                    <i class="fa fa-tags"></i>
                  </div>
                  <div>
                    <div class="decision-pill__title">Giữ mức học phí hiện tại</div>
                    <div class="decision-pill__desc">Không thay đổi quyền lợi trong thời gian giữ chỗ.</div>
                  </div>
                </div>
                <div class="decision-pill">
                  <div class="decision-pill__icon decision-pill__icon--pink">
                    <i class="fa fa-gift"></i>
                  </div>
                  <div>
                    <div class="decision-pill__title">Giữ voucher/ưu đãi đang áp dụng</div>
                    <div class="decision-pill__desc">Bảo lưu ưu đãi trước khi khách hàng chốt đăng ký.</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="update.customer_consult_id === phan_van" class="decision-section decision-section--booking mt-4">
              <div class="field-label">Đăng ký cọc ngay</div>
              <ValidationProvider
                vid="fee"
                name="Số tiền cọc"
                :rules="depositAmountRules"
                v-slot="{ errors, classes }"
              >
                <el-input
                  :value="formattedDepositAmount"
                  :class="classes"
                  placeholder="Nhập số tiền cọc"
                  class="decision-money__input"
                  type="text"
                  inputmode="numeric"
                  @input="handleDepositAmountInput"
                >
                  <template slot="prepend">
                    <span class="money-prefix">
                      <i class="fa fa-money"></i>
                      VND
                    </span>
                  </template>
                  <template slot="append">VND</template>
                </el-input>
                <div class="fv-plugins-message-container">
                  <div class="fv-help-block">{{ errors[0] }}</div>
                </div>
              </ValidationProvider>

              <div class="decision-payment mt-4">
                <div class="field-label">Hình thức thanh toán cọc</div>
                <div class="decision-payment__grid">
                  <button
                    v-for="method in depositMethods"
                    :key="method.id"
                    type="button"
                    class="payment-method"
                    :class="{ 'payment-method--active': update.deposit_method_id === method.id }"
                    @click="selectDepositMethod(method.id)"
                  >
                    <div class="payment-method__icon">
                      <i :class="method.icon"></i>
                    </div>
                    <div class="payment-method__label">{{ method.label }}</div>
                  </button>
                </div>
                <div class="decision-payment__note">
                  Khách hàng có thể thanh toán tiền cọc để giữ học phí và các ưu đãi/voucher hiện có. Số tiền cọc có thể
                  được khấu trừ vào học phí khi ký hợp đồng.
                </div>
                <ValidationProvider
                  vid="deposit_method_id"
                  name="Hình thức thanh toán cọc"
                  :rules="depositRequiredRules"
                  v-slot="{ errors }"
                >
                  <input v-model="update.deposit_method_id" type="hidden" />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>

              <div class="decision-center mt-4">
                <div class="field-label">Trung tâm <span class="text-danger">*</span></div>
                <ValidationProvider
                  vid="center_id"
                  name="Trung tâm"
                  :rules="depositRequiredRules"
                  v-slot="{ errors, classes }"
                >
                  <el-select
                    v-model="update.center_id"
                    class="decision-select"
                    clearable
                    filterable
                    placeholder="Chọn trung tâm"
                    :class="classes"
                  >
                    <el-option
                      v-for="item in centers"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">{{ errors[0] }}</div>
                  </div>
                </ValidationProvider>
              </div>

              <div class="decision-benefit mt-4">
                <div class="decision-benefit__title">Ưu đãi hiện tại của khách hàng</div>
                <div class="decision-benefit__grid">
                  <div class="benefit-card">
                    <div class="benefit-card__icon benefit-card__icon--pink">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <div>
                      <div class="benefit-card__label">Hạn giữ ưu đãi</div>
                      <div class="benefit-card__value">{{ benefitExpiryText }}</div>
                    </div>
                  </div>
                  <div class="benefit-card">
                    <div class="benefit-card__icon benefit-card__icon--green">
                      <i class="fa fa-info-circle"></i>
                    </div>
                    <div>
                      <div class="benefit-card__label">Gợi ý</div>
                      <div class="benefit-card__value">{{ benefitSuggestionText }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section v-if="update.customer_consult_id === khong_dang_ky" class="decision-section mt-4">
            <div class="field-label">Lý do từ chối <span class="text-danger">*</span></div>
            <ValidationProvider
              vid="reason"
              name="Lý do"
              :rules="{ required: true }"
              v-slot="{ errors, classes }"
            >
              <el-input
                v-model="update.reason"
                :class="classes"
                :rows="3"
                placeholder="Nhập lý do khách hàng từ chối"
                type="textarea"
              />
              <div class="fv-plugins-message-container">
                <div class="fv-help-block">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
          </section>

          <section v-if="update.customer_consult_id === dang_ky" class="decision-section decision-section--booking mt-4">
            <div class="field-label">Sản phẩm đăng ký <span class="text-danger">*</span></div>
            <ValidationProvider
              vid="product_type_id"
              name="Sản phẩm đăng ký"
              :rules="{ required: true }"
              v-slot="{ errors, classes }"
            >
              <el-select
                v-model="update.product_type_id"
                class="decision-select"
                clearable
                placeholder="Chọn sản phẩm đăng ký"
                :class="classes"
              >
                <el-option
                  v-for="item in PRODUCT_CUSTOMER_SELECT"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
              <div class="fv-plugins-message-container">
                <div class="fv-help-block">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>

            <div class="decision-info mt-3">
              Bạn đã nhập kết quả tư vấn là <strong>Khách hàng đăng ký</strong>. Tiếp theo, hãy tạo phiếu đăng ký học
              tập cho khách hàng.
            </div>
          </section>
        </form>
      </ValidationObserver>

            <template slot="footer">
                <div class="decision-footer">
                    <div class="decision-footer__hint">
                        <i class="fa fa-lock"></i>
                        Thông tin được lưu để quản lý chăm sóc khách hàng và theo dõi tiến trình tư vấn.
                    </div>
                    <div class="decision-footer__actions">
                        <el-button @click="dialogConsultResult = false">Hủy</el-button>
                        <el-button v-if="this.isTvvHN02" type="primary" :loading="loading" @click="submitFormNewVersion">Lưu kết quả (New Version)</el-button>
                        <el-button v-else type="primary" :loading="loading" @click="submitForm">Lưu kết quả</el-button>
                    </div>
                </div>
            </template>
        </el-dialog>

    <CashHandoverDialog
      :visible.sync="dialogPaymentOption"
      :payment-option="paymentOption"
      :mode="paymentDialogMode"
      :payLink="payLink"
      @close="handlePaymentDialogClose"
    />
  </div>
</template>

<script>
import { CENTER_EDUTALK } from "@/core/config/center/centerOption";
import {
  CUSTOMER_SELECT_DECISION,
  DANG_KY,
  KHONG_DANG_KY,
  PHAN_VAN,
  PRODUCT_CUSTOMER_SELECT,
  SAN_PHAM_EDUTALK,
  SAN_PHAM_NHAN_DOI_TAC,
} from "@/core/config/customer/customerOption";
import { GET_CENTERS } from "@/core/services/store/center/center.module";
import {
    CUSTOMER_CONSULT_RESULT,
    GET_RESULT_TEST_INPUT,
} from "@/core/services/store/customer/customer.module";
import CashHandoverDialog from "./CashHandoverDialog.vue";
import { ECOACH } from "../../../../core/config/center/centerOption";
import { mapGetters } from "vuex";
const DEPOSIT_METHODS = [
  {
    id: 'transfer',
    label: "Chuyển khoản",
    icon: "fa fa-university",
  },
  {
    id: 'cash',
    label: "Tiền mặt",
    icon: "el-icon-money",
  },
  {
    id: 'card',
    label: "Quẹt thẻ",
    icon: "fa fa-credit-card",
  },
];

const buildUpdate = (customer = {}) => ({
  customer_consult_id: customer.customer_consult_id ? parseInt(customer.customer_consult_id, 10) : "",
  product_type_id: customer.product_type_id ? parseInt(customer.product_type_id, 10) : "",
  reason: customer.reason || "",
  id: customer.id,
  level: customer.level || "3B",
  customer_id: customer.id ? parseInt(customer.id, 10) : "",
  center_id: customer.center_id ? parseInt(customer.center_id, 10) : "",
  fee: customer.fee || "",
  deposit_method_id: customer.deposit_method_id ?? "",
});

export default {
    name: "CustomerDecision",
    components: {
        CashHandoverDialog,
    },
    props: {
        customer: {
            type: Object,
            default: () => null,
        },
    },
    data() {
        const customer = this.customer || {};
        return {
            isNewVersion : false,
            loading: false,
            dialogConsultResult: false,
            centers: [],
            depositMethods: DEPOSIT_METHODS,
            update: buildUpdate(customer),
            CUSTOMER_SELECT_DECISION,
            PRODUCT_CUSTOMER_SELECT,
            khong_dang_ky: KHONG_DANG_KY,
            dang_ky: DANG_KY,
            phan_van: PHAN_VAN,
            SAN_PHAM_EDUTALK,
            SAN_PHAM_NHAN_DOI_TAC,
            paymentOption: [],
            dialogPaymentOption: false,
            paymentDialogMode: "transfer",
            pendingRedirect: null,
            ECOACH,
            payLink: ''
        };
    },
    computed: {
        ...mapGetters(["currentUser"]),
        formattedDepositAmount() {
            return this.formatDepositAmount(this.update.fee);
        },
        hasDepositAmount() {
            return !!String(this.update.fee || "").trim();
        },
        depositAmountRules() {
            return {
                // regex: /^[1-9]\d*$/,
            };
        },
        depositRequiredRules() {
            return this.hasDepositAmount ? { required: true } : {};
        },
        benefitExpiryText() {
            return this.getNextMonthDayEight();
        },
        benefitSuggestionText() {
            return "Đặt cọc trước thời hạn để giữ quyền lợi ưu đãi cho khách hàng.";
        },
        shouldCheckTestScoreBeforeContract() {
            return false;
        },
        //     return (
        //         this.update.customer_consult_id === DANG_KY &&
        //         this.update.product_type_id === SAN_PHAM_EDUTALK
        //     );
        // },
        isTvvHN02(){
          //return this.currentUser?.id === 289858;
          return (this.currentUser?.user_positions?.map(item => item?.position).includes('TVV') && this.currentUser?.profile?.area?.id == 2);
        }
    },
    watch: {
        customer: {
            immediate: true,
            deep: true,
            handler(val) {
                this.update = buildUpdate(val || {});
            },
        },
        "update.customer_consult_id"(value) {
            if (value !== this.dang_ky) {
                this.update.fee = "";
                this.update.deposit_method_id = 1;
                this.update.center_id = this.update.center_id || (this.customer && this.customer.center_id) || "";
            }
        },
    },
    async mounted() {
        await this.fetchCenters();
    },
    methods: {
        submitFormNewVersion(){
            this.isNewVersion = true;
            this.submitForm()
        },
        buildPaymentLink(centerId, paymentCode){
            const code = (paymentCode || '').toString().trim();
            if (!code) return '';
            const base =
                Number(centerId) === ECOACH
                    ? 'https://payment.ecoach.vn/?payment_option='
                    : 'https://payment.ieltsmentor.edu.vn/?payment_option=';
            return `${base}SF${code}`;
        },
        openDialog() {
            this.update = buildUpdate(this.customer || {});
            this.dialogConsultResult = true;
        },
        async fetchCenters() {
            try {
                const response = await this.$store.dispatch(GET_CENTERS, {
                    limit: 10000,
                    is_edutalk: CENTER_EDUTALK,
                    status: 1,
                });
                this.centers = response?.data?.data || [];
            } catch (error) {
                this.centers = [];
            }
        },
        formatDepositAmount(value) {
            const digits = String(value ?? "").replace(/\D/g, "");
            if (!digits) {
                return "";
            }
            return Number(digits).toLocaleString("vi-VN");
        },
        handleDepositAmountInput(value) {
            const digits = String(value ?? "").replace(/\D/g, "");
            this.update.fee = digits === "0" ? "" : digits;
        },
        selectDepositMethod(methodId) {
            this.$set(this.update, "deposit_method_id", methodId);
        },
        async submitForm() {
            const isValid = await this.$refs.form.validate();
            if (!isValid) {
                return;
            }
            if (!this.hasDepositAmount) {
                this.update.deposit_method_id = null;
                this.update.center_id = null;
            }
            if (this.update.customer_consult_id === KHONG_DANG_KY) {
                this.update.level = "1A";
            }
            this.register();
        },
        async register() {
            this.loading = true;
            if (this.shouldCheckTestScoreBeforeContract) {
                const ok = await this.checkTestScoreBeforeContract();
                if (!ok) {
                    this.loading = false;
                    return;
                }
            }
            this.saveConsultResult();
        },
        checkTestScoreBeforeContract() {
            const customerId = this.update.customer_id || this.customer?.id;
            return this.$store
                .dispatch(GET_RESULT_TEST_INPUT, customerId)
                .then(() => true)
                .catch((e) => {
                    this.$message.error({
                        message:
                            e?.data?.message ||
                            "Học viên cần có phiếu điểm Test trước khi tạo hợp đồng.",
                        showClose: true,
                    });
                    return false;
                });
        },
        saveConsultResult() {
            this.$store
                .dispatch(CUSTOMER_CONSULT_RESULT, this.update)
                .then((data) => {
                    this.paymentOption = data.data;
                    this.$message.success(data.message);
                    this.dialogConsultResult = false;
                    this.payLink = this.buildPaymentLink(this.customer.center_id, this.paymentOption.payment_code);
                    this.redirect();
                })
                .catch((e) => {
                    const formErrors = e?.data?.data?.message_validate_form;
                    if (formErrors) {
                        this.$refs.form.setErrors(formErrors);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        redirect() {
            const nextRoute = this.resolveNextRoute();
            if (this.update.deposit_method_id === 'cash' || this.update.deposit_method_id === 'transfer') {
                this.pendingRedirect = nextRoute;
                this.paymentDialogMode = this.update.deposit_method_id;
                this.dialogPaymentOption = true;
                return;
            }
            this.goToRoute(nextRoute);
        },
        resolveNextRoute() {
            switch (this.update.customer_consult_id) {
                case this.phan_van:
                case this.khong_dang_ky:
                    return {
                        name: "list-customer-tvv",
                        params: {
                            customer_id: this.customer.id,
                        },
                    };
                case this.dang_ky:
                    if (this.update.product_type_id === 1 ) {
                        return {
                            name: this.isNewVersion ? "register-study-v2" : "register-study",
                            query: {
                                customer_id: this.customer.id,
                            },
                        };
                    }
                    return {
                        name: "register-study-partner",
                        query: {
                            customer_id: this.customer.id,
                        },
                    };
                default:
                    return null;
            }
        },
        goToRoute(route) {
            if (!route) {
                return;
            }
            this.$router.push(route);
        },
        handlePaymentDialogClose() {
            const nextRoute = this.pendingRedirect;
            this.pendingRedirect = null;
            this.paymentDialogMode = "transfer";
            this.goToRoute(nextRoute);
        },
        handleConsult() {
            switch (this.update.customer_consult_id) {
                case this.phan_van:
                    this.update.level = "3E";
                    break;
                case this.khong_dang_ky:
                    this.update.level = "3C";
                    break;
                case this.dang_ky:
                    this.update.level = "";
                    break;
            }
        },
        getNextMonthDayEight() {
            const now = new Date();
            const year = now.getMonth() === 11 ? now.getFullYear() + 1 : now.getFullYear();
            const month = now.getMonth() === 11 ? 0 : now.getMonth() + 1;
            const day = "08";
            const formattedMonth = String(month + 1).padStart(2, "0");
            return `${day}/${formattedMonth}/${year}`;
        },
    },
};
</script>

<style scoped>
.decision-dialog__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.decision-dialog__title-wrap {
    display: flex;
    align-items: center;
    gap: 14px;
}

.decision-dialog__icon {
    width: 36px;
    height: 36px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #8b5cf6;
    background: linear-gradient(135deg, #f3e8ff, #ede9fe);
    font-size: 18px;
}

.decision-dialog__title {
    font-size: 22px;
    font-weight: 800;
    color: #1f2937;
    line-height: 1.2;
}

.decision-dialog__subtitle {
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
}

.decision-dialog__close {
    border: 0;
    background: transparent;
    color: #9ca3af;
    font-size: 24px;
    line-height: 1;
    padding: 0;
}

.decision-form {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.decision-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.field-label {
    font-size: 15px;
    font-weight: 700;
    color: #374151;
}

.decision-select {
    width: 100%;
}

.decision-note {
    border: 1px solid #f4d48a;
    border-radius: 16px;
    background: #fff9e8;
    padding: 18px 18px 16px;
}

.decision-note__title {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #d97706;
    font-size: 16px;
    font-weight: 800;
    margin-bottom: 10px;
}

.decision-note__list {
    margin: 0;
    padding-left: 18px;
    color: #b45309;
    line-height: 1.65;
}

.decision-note__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin-top: 16px;
}

.decision-pill {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fff;
    border: 1px solid #f1f5f9;
    border-radius: 14px;
    padding: 14px;
    min-height: 70px;
}

.decision-pill__icon {
    width: 38px;
    height: 38px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #7c3aed;
    background: #f3e8ff;
    flex: 0 0 auto;
}

.decision-pill__icon--pink {
    color: #db2777;
    background: #fce7f3;
}

.decision-pill__title {
    font-size: 13px;
    font-weight: 700;
    color: #374151;
}

.decision-pill__desc {
    font-size: 12px;
    color: #6b7280;
    margin-top: 2px;
}

.decision-info {
    font-size: 14px;
    color: #4b5563;
    background: #f8fafc;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 12px 14px;
}

.decision-money,
.decision-payment,
.decision-center,
.decision-benefit {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.decision-money__title,
.decision-benefit__title {
    font-size: 15px;
    font-weight: 700;
    color: #374151;
}

.money-prefix {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #7c3aed;
    font-weight: 700;
}

.decision-payment__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
}

.payment-method {
    border: 1px solid #e5e7eb;
    background: #fff;
    border-radius: 12px;
    padding: 14px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    transition: 0.18s ease;
}

.payment-method--active {
    border-color: #6d28d9;
    box-shadow: 0 0 0 1px rgba(109, 40, 217, 0.15) inset;
    background: linear-gradient(180deg, #f7f2ff, #ffffff);
}

.payment-method__icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    background: #f3f4f6;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #4b5563;
    font-size: 16px;
}

.payment-method--active .payment-method__icon {
    background: #ede9fe;
    color: #6d28d9;
}

.payment-method__label {
    font-size: 12px;
    line-height: 1.3;
    font-weight: 700;
    color: #4b5563;
    text-align: center;
}

.decision-payment__note {
    font-size: 12px;
    line-height: 1.6;
    color: #6b7280;
}

.decision-benefit__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    border: 1px solid #e5e7eb;
    border-radius: 14px;
    overflow: hidden;
    background: #fff;
}

.benefit-card {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 16px;
}

.benefit-card:first-child {
    border-right: 1px solid #e5e7eb;
}

.benefit-card__icon {
    width: 36px;
    height: 36px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    font-size: 16px;
}

.benefit-card__icon--pink {
    background: #fce7f3;
    color: #db2777;
}

.benefit-card__icon--green {
    background: #dcfce7;
    color: #16a34a;
}

.benefit-card__label {
    font-size: 12px;
    color: #6b7280;
}

.benefit-card__value {
    font-size: 14px;
    font-weight: 700;
    color: #111827;
    margin-top: 3px;
}

.decision-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.decision-footer__hint {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #94a3b8;
    font-size: 12px;
    line-height: 1.5;
    max-width: 340px;
}

.decision-footer__actions {
    display: flex;
    align-items: center;
    gap: 10px;
}

@media (max-width: 768px) {
    .decision-note__grid,
    .decision-payment__grid,
    .decision-benefit__grid {
        grid-template-columns: 1fr;
    }

    .benefit-card:first-child {
        border-right: 0;
        border-bottom: 1px solid #e5e7eb;
    }

    .decision-footer {
        flex-direction: column;
        align-items: stretch;
    }

    .decision-footer__actions {
        justify-content: flex-end;
    }
}
</style>

<style>
.customer-decision-dialog .el-dialog__header {
    padding: 22px 24px 16px;
    border-bottom: 1px solid #eef2f7;
}

.customer-decision-dialog .el-dialog__body {
    padding: 22px 24px 18px;
}

.customer-decision-dialog .el-dialog__footer {
    padding: 18px 24px 24px;
    border-top: 1px solid #eef2f7;
}

.customer-decision-dialog .el-input__inner,
.customer-decision-dialog .el-textarea__inner {
    border-radius: 12px;
}

.customer-decision-dialog .el-input-group__prepend,
.customer-decision-dialog .el-input-group__append {
    border-radius: 12px;
    background: #faf5ff;
    color: #6d28d9;
    font-weight: 700;
    border-color: #e9d5ff;
}

.customer-decision-dialog .el-input__inner:focus,
.customer-decision-dialog .el-textarea__inner:focus {
    border-color: #6d28d9;
}

.customer-decision-dialog .el-checkbox__inner:hover,
.customer-decision-dialog .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #472f92;
}

.customer-decision-dialog .el-checkbox__input.is-checked .el-checkbox__inner,
.customer-decision-dialog .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #472f92;
    background-color: #472f92;
}

.customer-decision-dialog .el-checkbox__input.is-checked + .el-checkbox__label,
.customer-decision-dialog .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #472f92;
}
</style>
